/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InitiativeControlMappingDto } from './InitiativeControlMappingDto';
import {
    InitiativeControlMappingDtoFromJSON,
    InitiativeControlMappingDtoFromJSONTyped,
    InitiativeControlMappingDtoToJSON,
    InitiativeControlMappingDtoToJSONTyped,
} from './InitiativeControlMappingDto';
import type { CreateMilestoneRequest } from './CreateMilestoneRequest';
import {
    CreateMilestoneRequestFromJSON,
    CreateMilestoneRequestFromJSONTyped,
    CreateMilestoneRequestToJSON,
    CreateMilestoneRequestToJSONTyped,
} from './CreateMilestoneRequest';

/**
 * 
 * @export
 * @interface CreateInitiativeRequest
 */
export interface CreateInitiativeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    intent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    drivenBy?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    ownerUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeRequest
     */
    budgetAllocated?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    budgetCurrency?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateInitiativeRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateInitiativeRequest
     */
    targetDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeRequest
     */
    priorityRank?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeRequest
     */
    targetMaturity?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    lifecyclePhase?: string;
    /**
     * 
     * @type {Array<CreateMilestoneRequest>}
     * @memberof CreateInitiativeRequest
     */
    milestones?: Array<CreateMilestoneRequest>;
    /**
     * 
     * @type {Array<InitiativeControlMappingDto>}
     * @memberof CreateInitiativeRequest
     */
    controlMappings?: Array<InitiativeControlMappingDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreateInitiativeRequest interface.
 */
export function instanceOfCreateInitiativeRequest(value: object): value is CreateInitiativeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateInitiativeRequestFromJSON(json: any): CreateInitiativeRequest {
    return CreateInitiativeRequestFromJSONTyped(json, false);
}

export function CreateInitiativeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInitiativeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'intent': json['intent'] == null ? undefined : json['intent'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'budgetAllocated': json['budgetAllocated'] == null ? undefined : json['budgetAllocated'],
        'budgetCurrency': json['budgetCurrency'] == null ? undefined : json['budgetCurrency'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'priorityRank': json['priorityRank'] == null ? undefined : json['priorityRank'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'lifecyclePhase': json['lifecyclePhase'] == null ? undefined : json['lifecyclePhase'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(CreateMilestoneRequestFromJSON)),
        'controlMappings': json['controlMappings'] == null ? undefined : ((json['controlMappings'] as Array<any>).map(InitiativeControlMappingDtoFromJSON)),
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreateInitiativeRequestToJSON(json: any): CreateInitiativeRequest {
    return CreateInitiativeRequestToJSONTyped(json, false);
}

export function CreateInitiativeRequestToJSONTyped(value?: CreateInitiativeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'intent': value['intent'],
        'profileId': value['profileId'],
        'drivenBy': value['drivenBy'],
        'ownerUserId': value['ownerUserId'],
        'budgetAllocated': value['budgetAllocated'],
        'budgetCurrency': value['budgetCurrency'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'priorityRank': value['priorityRank'],
        'capabilityDomain': value['capabilityDomain'],
        'targetMaturity': value['targetMaturity'],
        'lifecyclePhase': value['lifecyclePhase'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(CreateMilestoneRequestToJSON)),
        'controlMappings': value['controlMappings'] == null ? undefined : ((value['controlMappings'] as Array<any>).map(InitiativeControlMappingDtoToJSON)),
        'effectTenantId': value['effectTenantId'],
    };
}

